import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { ILocation, TDateRange } from '@/shared/types/app.types';
import { IObject } from '@/shared/types/bookingObjects.types';

interface AppStore {
	isMobile: boolean | null;
	workTime: TDateRange;
	date: TDateRange;
	location: ILocation | null;
	currentLocation: IObject | null;
	setDate: (date: AppStore['date']) => void;
	setLocation: (location: AppStore['location']) => void;
	setCurrentLocation: (location: AppStore['currentLocation']) => void;
	setIsMobile: (isMobile: AppStore['isMobile']) => void;
}

const useAppStore = create<AppStore>()(
	devtools((set) => ({
		isMobile: null,
		workTime: [null, null],
		date: JSON.parse(sessionStorage.getItem('date') ?? '[null, null]'),
		location: JSON.parse(localStorage.getItem('location') as string) as ILocation | null,
		currentLocation: JSON.parse(
			localStorage.getItem('currentLocation') as string,
		) as IObject | null,
		isAdmin: false,
		isModerator: false,
		setDate: (date) =>
			set(() => {
				sessionStorage.setItem('date', JSON.stringify(date));
				return { date };
			}),
		setLocation: (location) =>
			set(() => {
				const formatedParking = location?.parking?.map(
					({ children, change_history_list, attributes, bookings, svg, ...rest }) => ({ ...rest }),
				);
				const formatedRoute = location?.route?.map(
					({ children, change_history_list, attributes, bookings, svg, ...rest }) => ({ ...rest }),
				);
				localStorage.setItem(
					'location',
					JSON.stringify({ parking: formatedParking, route: formatedRoute }),
				);
				return { location };
			}),
		setCurrentLocation: (currentLocation) =>
			set(() => {
				localStorage.setItem('currentLocation', JSON.stringify(currentLocation));
				return { currentLocation };
			}),
		setIsMobile: (isMobile) => set(() => ({ isMobile })),
	})),
);

export default useAppStore;
